import React, { useEffect, useState } from 'react'
import { useModal } from '../../contexts/modal'
import isEqual from 'lodash.isequal'
import service from '../../service'

const DEFAULT_CUSTOMER = {
  bizName: '',
  firstName: '',
  lastName: '',
  phone: '', //type=string
  user: {
    email: ''
  }
}
const CustomerInfoModal = ({ customer, getCustomers }) => {
  const [updatedCustomer, setUpdatedCustomer] = useState(DEFAULT_CUSTOMER)
  const [isError, setIsError] = useState(false)
  const { modalMethods } = useModal()

  const checkForChangesInCustomer = () => {
    return isEqual(updatedCustomer, customer)
  }

  useEffect(() => {
    setUpdatedCustomer(customer)
  }, [])

  const submitNewCustomerInfo = async (e) => {
    e.preventDefault()
    const res = await service.updateCustomerFromCustomerList(updatedCustomer)
    if (res.ok) {
      getCustomers()
      modalMethods.close()
    } else {
      setIsError(true)
    }

  }

  return (
    <div className='absolute bg-navy-bright10 w-full sm:w-3/4 lg:w-1/2 items-center border rounded-2xl py-4 px-6 font-roboto'>
      <div className='flex justify-between'>
        <div className='text-dark-blue font-bold mb-3 text-[21px]'>
          Customer Info
        </div>
        <button>
          <img src='/close_dark.svg' onClick={() => {
            modalMethods.close();
          }} />
        </button>
      </div>
      <form className='py-3 flex-row' onSubmit={(e) => { submitNewCustomerInfo(e) }}>
        <div className='w-full flex gap-6'>
          <div className='w-1/2'>
            <div className='text-dark-blue font-normal text-xs mb-1 font-roboto'>
              Business name *
            </div>
            <input
              className='w-full mb-3 border rounded border-navy-light'
              value={updatedCustomer.bizName}
              onChange={(e) => {
                const newCustomer = {
                  ...updatedCustomer,
                  bizName: e.target.value
                }
                setUpdatedCustomer(newCustomer)
              }}
            />
            <div className='text-dark-blue font-normal text-xs mb-1 font-roboto'>
              First name *
            </div>
            <input
              className='w-full mb-3 border rounded border-navy-light'
              value={updatedCustomer.firstName}
              onChange={(e) => {
                const newCustomer = {
                  ...updatedCustomer,
                  firstName: e.target.value
                }
                setUpdatedCustomer(newCustomer)
              }}
            />
            <div className='text-dark-blue font-normal text-xs mb-1 font-roboto'>
              Last name *
            </div>
            <input
              className='w-full mb-3 border rounded border-navy-light'
              value={updatedCustomer.lastName}
              onChange={(e) => {
                const newCustomer = {
                  ...updatedCustomer,
                  lastName: e.target.value
                }
                setUpdatedCustomer(newCustomer)
              }}
            />
          </div>
          <div className='flex flex-col w-1/2'>
            <div className='text-dark-blue font-normal text-xs mb-1 font-roboto'>
              Email
            </div>
            <input
              className='w-full mb-3 border text-gray-blue border-navy-light bg-navy-light bg-opacity-90 rounded'
              value={updatedCustomer.user.email}
              disabled={true}
            />
            <div className='text-dark-blue font-normal text-xs mb-1 font-roboto'>
              Phone
            </div>
            <input
              className='w-full mb-3 border rounded border-navy-light'
              onChange={(e) => {
                const newCustomer = {
                  ...updatedCustomer,
                  phone: e.target.value
                }
                setUpdatedCustomer(newCustomer)
              }}
              value={updatedCustomer.phone}
            />
            <div className='flex justify-end gap-6'>
              {isError
                ?
                <p className='font-bold text-gunite-red mt-7'>There was an error.  Please try again.</p>
                :
                null}
              <button
                className={`border rounded border-jet-black/10 bg-dark-blue py-2 px-3 font-semibold text-base text-white mt-[20px] self-end ${checkForChangesInCustomer() ? 'bg-jet-black/10 text-jet-black/40' : 'text-white bg-dark-blue'}`}
                type='submit'
                disabled={checkForChangesInCustomer()}
              >Submit</button>

            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CustomerInfoModal